import React from 'react';
import {SyncedStatusProps} from './SyncedStatus.props';
import './SyncedStatus.styles.css';
import Box from "@mui/material/Box";
import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";

const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 400,
  },
});

export const SyncedStatus: React.FC<SyncedStatusProps> = ({value, icon, valueColor, tooltip}) => {

  return (
    <CustomWidthTooltip title={tooltip} placement="top">
      <Box className={'synced-status-card'}>
        {icon}
        <span style={{
          fontSize: '14px',
          fontFamily: 'Montserrat',
          fontWeight: 700,
          marginLeft: '8px',
          position: 'relative',
          top: '2px',
          color: valueColor
        }}>
            {value}
        </span>
      </Box>
    </CustomWidthTooltip>
  );
};
